import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useCallback, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {ApiResponse} from '../../../data/types/interface/api';
import {StackParams} from '../../../data/types/navigation';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {Container} from '../../components/Container';
import {DetailDemarcheItem} from '../../components/DetailDemarcheItem';
import {HeaderScreen} from '../../components/Header/HeaderScreen';
import {Loader} from '../../components/Loader';

type NavigationProps = StackNavigationProp<StackParams, 'Details'>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function DetailScreen(props: any) {
  const {navigate} = useNavigation<NavigationProps>();
  const {id, nom, isCatalogue, path} = props.route.params;
  const {getCatalogue, getDemarche, user} = props;

  const [description, setDescription] = useState('');
  const [isLoading, setLoading] = useState(true);
  const [nameSimulation, setSimulationName] = useState('');
  const [nameDevis, setDevisName] = useState('');
  const [checkSimulation, setSimulation] = useState(true);
  const [checkDevis, setDevis] = useState(true);
  const [sourceImage, setSourceImage] = useState('');
  const [idDevis, setIdDevis] = useState('');

  useEffect(() => {
    if (isCatalogue) {
      getCatalogue(
        {},
        (res: ApiResponse) => {
          if (res && res.data) {
            setDescription(res.data.description);
            setSourceImage(res.data.imageUrl);
            if (res.data.typeContrat) {
              setSimulation(true);
              setSimulationName(res.data.typeContrat.nom);
            } else {
              setSimulation(false);
            }
            if (res.data.typeSimulation) {
              setDevis(true);
              setDevisName(res.data.typeSimulation.nom);
            } else {
              setDevis(false);
            }
            setLoading(false);
          }
        },
        `/${id}`,
      );
    } else {
      getDemarche(
        {},
        (res: ApiResponse) => {
          if (res && res.data) {
            setDescription(res.data.description);
            setSourceImage(res.data.imageUrl);
            if (res.data.typeContrat) {
              setSimulation(true);
              setSimulationName(res.data.typeContrat.nom);
            } else {
              setSimulation(false);
            }
            if (res.data.typeSimulation) {
              setDevis(true);
              setDevisName(res.data.typeSimulation.nom);
              setIdDevis(res.data.typeSimulation.id);
            } else {
              setDevis(false);
            }
            setLoading(false);
          }
        },
        `/${id}`,
      );
    }
  }, []);

  const handleSouscrire = () => {
    switch (nameSimulation) {
      case 'Assurance retraite':
        user && user.data && user.data.utilisateur
          ? navigate('SouscriptionAssuranceRetraiteForm', {
              premierVersement: '',
            })
          : navigate('Login', {data: 'SouscriptionAssuranceRetraiteForm'});
        break;
      case 'Assurance RC Vie Privée':
        user && user.data && user.data.utilisateur
          ? navigate('SouscriptionAssuranceRCVPForm', {typeId: id})
          : navigate('Login', {
              data: 'SouscriptionAssuranceRCVPForm',
              typeId: id,
            });
        break;
      case 'Assurance scolaire':
        user && user.data && user.data.utilisateur
          ? navigate('SouscriptionAssuranceScolaireForm', {
              montant: '',
              typeId: id,
            })
          : navigate('Login', {
              data: 'SouscriptionAssuranceScolaireForm',
              typeId: id,
            });
        break;
    }
  };

  const handleDemande = useCallback(() => {
    switch (nameDevis) {
      case 'Famille':
        navigate('AssuranceScolaire', {id: idDevis});
        break;
      case 'Epargne et prévoyance':
        navigate('Cotisation');
        break;
    }
  }, [nameDevis]);

  return (
    <Container>
      <HeaderScreen title={path} type="retour" noBreadcrumb={false} />
      {isLoading ? (
        <Loader />
      ) : (
        <DetailDemarcheItem
          description={description}
          title={nom}
          srcImage={sourceImage}
          handleSouscrire={checkSimulation ? handleSouscrire : null}
          handleDemande={checkDevis ? handleDemande : null}
        />
      )}
    </Container>
  );
}

export const DetailsDemarche = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DetailScreen);
